export default function (state, value) {
    state.type = (value && value === 'min') ? value : 'max';
}